/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';

import {
    Card,
    Divider,
    Spacer,
    Property,
    BookingStatus,
    SpaceBookingsTable
} from 'school-space-client/components';
import { getDateStringWithYear } from 'school-space-utils/date';

import RecurringBookingCardActionButtons from './RecurringBookingCardActionButtons';
import css from './css';

const RecurringBookingCard = ({ booking, onUpdate }) => {
    const { recurrence, startDate, endDate, location, spaces, state } = booking;
    const showBookingStatus = state.id === 'prospective' || state.id === 'cancelled';

    return (
        <Card styles={css.wrapper}>
            <div css={css.header}>
                <div css={css.propertyRow}>
                    <Property title="Repeats" styles={css.property}>
                        {recurrence}
                    </Property>
                    <Property title="Location" styles={css.property}>
                        {location}
                    </Property>
                </div>
                <div css={css.meta}>{showBookingStatus && <BookingStatus state={state.id} />}</div>
            </div>
            <div css={css.header}>
                <div css={css.propertyRow}>
                    <Property title="Start date" styles={css.property}>
                        {getDateStringWithYear(startDate)}
                    </Property>
                    <Property title="End date" styles={css.property}>
                        {getDateStringWithYear(endDate)}
                    </Property>
                </div>
            </div>
            <div css={css.spaces}>
                <SpaceBookingsTable spaceBookings={spaces} />
            </div>
            <Divider />
            <Spacer />
            <RecurringBookingCardActionButtons booking={booking} onUpdate={onUpdate} />
        </Card>
    );
};

RecurringBookingCard.propTypes = {
    booking: PropTypes.objectOf(PropTypes.any).isRequired,
    onUpdate: PropTypes.func.isRequired
};

export default RecurringBookingCard;
